import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import IconKlarway from './assets/images/iconKlarway.png'
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'© . '}
      {new Date().getFullYear()}{' '}
      <Link color="inherit" href="https://klarway.com/">
        Klarway
      </Link>
      {'.'}
      {' Todos los derechos reservados. '}
    </Typography>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#009efd',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    poster: {
      color: '009efd',
    },
    h6: {
      color: '#009efd'
    },
  },
});

export default function SignIn() {

  const [open, setOpen] = React.useState(false);
  const handleSubmit = (event) => {
    // console.log('event.currentTarget', event.currentTarget)
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (data.get('user') == data.get('password')) {
      // userLogin(data.get('user'))
      localStorage.setItem('user', data.get('user'))
      // console.log('Guardo el user en local sstorage', data.get('user'))
      global.loginSuccessful()
    } else {
      setOpen(true);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <Collapse in={open}>
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            Usuario o contraseña incorrecta!
          </Alert>
        </Collapse>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar src={IconKlarway} sx={{ m: 1, width: 56, height: 56 }}></Avatar>
          <Typography color={'#009efd'} component="h1" variant="h6">
            INICIAR SESIÓN EN EXÁMENES ONLINE
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="user"
              label="Usuario"
              name="user"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
            />
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
            <Button
              color="primary"
              type="submit"
              style={{ color: '#fff' }}
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Ingresar
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}